export default class PasswordChange {
  originalPassword: string | null = null
  newPassword: string | null = null
  confirmPassword: string | null = null
}
